import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { Store } from "@ngrx/store";
import { auditTime, distinctUntilChanged, first } from "rxjs/operators";
import * as fromApp from "../../store/app.reducer";
import * as selectors from "../../store/app.selectors";
import * as _ from "lodash";
import * as SelectedProductActions from "../store/selectedProduct.actions";
import { ProductDetailsOperationsService } from "../product-details-operations.service";
import { Subscription } from "rxjs";
import { roundQuantity } from "../../services/quantity-decimals";
@Component({
  selector: "app-options",
  templateUrl: "./options.component.html",
  styleUrls: ["./options.component.scss"],
})
export class OptionsComponent implements OnInit, OnDestroy {
  @Input() bundleMode: any;
  @Input() parentBundleChoice: any;
  @Input() selectedProductFromParent: any;
  @Input() groupStoreData: any;
  private subscription: Subscription;
  public selectedProduct: any;
  public must_select_something: any;
  public do_not_show_comments_option;

  // Progressive options rendering — opens products with many options (e.g. large
  // bundles) without jank by painting the first chunk immediately and appending the
  // rest over the next animation frames.
  public visibleOptionsCount = 0;
  private readonly optionsInitialChunk = 6;
  private readonly optionsChunkSize = 6;
  private optionsProgressiveDone = false;
  private optionsRafId: any = null;
  private validationFlushSub: Subscription;
  private validationFlushInitialized = false;
  private lastSeenValidationTimestamp: any = null;
  private cachedVisibleOptions: any[] = [];
  private cachedOptionsRef: any = null;
  private cachedVisibleCount = -1;

  constructor(
    private store: Store<fromApp.AppState>,
    private productDetailsOperationsService: ProductDetailsOperationsService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    if (this.selectedProductFromParent) {
      this.selectedProduct = _.cloneDeep(this.selectedProductFromParent);
      this.productDetailsOperationsService.applyUposTabletFullscreenAlwaysSplitColumns(
        this.selectedProduct,
        window.innerWidth
      );
      this.must_select_something = this.selectedProduct.must_select_something;
      console.log("check dep options");
      this.checkIsDependentOptions();

      this.initProgressiveOptions();
      this.subscribeToValidationFlush();

      this.store
        .select(selectors.getStoreInfo)
        .pipe(first())
        .subscribe((store_info) => {
          this.store
            .select("deliveryMethodAddress")
            .pipe(first())
            .subscribe((state) => {
              // console.log(
              //   ":call product price",
              //   this.bundleMode,
              //   this.parentBundleChoice
              // );
              this.checkProductQuantityFromChoices(store_info);
              this.selectedProduct =
                this.productDetailsOperationsService.cartProductPrice(
                  _.cloneDeep(this.selectedProduct),
                  state.orderPickup,
                  state.dineIn,
                  this.parentBundleChoice && this.bundleMode
                    ? _.cloneDeep(this.parentBundleChoice)
                    : null,
                  null,
                  store_info && store_info.dinein
                    ? store_info.alt_dinein_active
                    : false,
                  state.selectedDineInTable,
                  store_info.decimalPlacesPrices
                );

              this.calculateIfShowFieldOption();
            })
            .unsubscribe();
        });

      this.writeProductToState();
    }
    this.subscription = this.store
      .select(
        selectors.getSelectedProductBySelectedProductId(
          this.selectedProductFromParent.selectedProductId
        )
      )
      .pipe(distinctUntilChanged())
      .pipe(auditTime(300))
      .subscribe((selectedProduct) => {
        if (
          (selectedProduct &&
            selectedProduct.quantity &&
            !_.isEqual(
              this.selectedProduct.quantity,
              selectedProduct.quantity
            )) ||
          !_.isEqual(this.selectedProduct.options, selectedProduct.options)
        ) {
          this.selectedProduct = _.cloneDeep(selectedProduct);
          // Once the progressive first-paint has finished, keep the whole list
          // visible across subsequent store updates (option contents change but the
          // set does not grow), so no option is ever hidden after the initial render.
          if (this.optionsProgressiveDone && this.selectedProduct.options) {
            this.visibleOptionsCount = this.selectedProduct.options.length;
          }
          this.productDetailsOperationsService.applyUposTabletFullscreenAlwaysSplitColumns(
            this.selectedProduct,
            window.innerWidth
          );
          this.calculateIfShowFieldOption();

          this.store
            .select(selectors.getStoreInfo)
            .pipe(first())
            .subscribe((store_info) => {
              this.store
                .select("deliveryMethodAddress")
                .pipe(first())
                .subscribe((state) => {
                  // console.log(
                  //   ":call product price",
                  //   this.bundleMode,
                  //   this.parentBundleChoice
                  // );
                  const tempProduct =
                    this.productDetailsOperationsService.cartProductPrice(
                      _.cloneDeep(this.selectedProduct),
                      state.orderPickup,
                      state.dineIn,
                      this.parentBundleChoice && this.bundleMode
                        ? _.cloneDeep(this.parentBundleChoice)
                        : null,
                      null,
                      store_info && store_info.dinein
                        ? store_info.alt_dinein_active
                        : false,
                      state.selectedDineInTable,
                      store_info.decimalPlacesPrices
                    );

                  this.calculateIfShowFieldOption();

                  if (
                    !_.isEqual(tempProduct, this.selectedProduct) &&
                    !_.find(this.selectedProduct.options || [], (opt) => {
                      return (
                        opt.bundle &&
                        opt.bundle_options &&
                        opt.bundle_options.preselectedQuantityZero
                      );
                    })
                  ) {
                    this.selectedProduct = _.cloneDeep(tempProduct);
                    this.productDetailsOperationsService.applyMoAppsIngoreAlwaysOpenOptions(
                      this.selectedProduct,
                      store_info
                    );
                    this.store.dispatch(
                      new SelectedProductActions.SetSelectedProduct(
                        _.cloneDeep(this.selectedProduct)
                      )
                    );
                  } else {
                    this.selectedProduct = _.cloneDeep(tempProduct);
                  }
                })
                .unsubscribe();
            })
            .unsubscribe();
        }
      });
  }

  trackFnc(index, option) {
    return option.product_id_option_id;
  }

  // The slice of options currently rendered. Once progressive rendering is done (or
  // for short lists) the full array reference is returned unchanged.
  get visibleOptions(): any[] {
    const options = this.selectedProduct && this.selectedProduct.options;
    if (!options) {
      return [];
    }
    // Fail open: if progressive rendering finished — or was never initialised — return
    // the full list so options can never be permanently hidden.
    if (this.optionsProgressiveDone || this.visibleOptionsCount <= 0) {
      return options;
    }
    // Memoise the slice: return the SAME array reference until the source array or the
    // visible count actually changes, so binding it to *ngFor never trips
    // ExpressionChangedAfterItHasBeenChecked in development.
    if (
      options !== this.cachedOptionsRef ||
      this.visibleOptionsCount !== this.cachedVisibleCount
    ) {
      this.cachedOptionsRef = options;
      this.cachedVisibleCount = this.visibleOptionsCount;
      this.cachedVisibleOptions = options.slice(0, this.visibleOptionsCount);
    }
    return this.cachedVisibleOptions;
  }

  checkIsDependentOptions() {
    console.log("checkIsDependentOptions", this.selectedProduct.options[0]);

    if (!this.selectedProduct) {
      return;
    }

    this.selectedProduct.options = _.filter(
      this.selectedProduct.options,
      (opt) => {
        return _.isObject(opt);
      }
    );

    const potentiallyDependentOptionIds = new Set<any>();
    _.each(this.selectedProduct.options, (option: any) => {
      if (!option || typeof option !== "object") {
        return;
      }

      const currentOption: any = option;
      const hasFrontendPotentialDependencyMarker =
        _.get(currentOption, "option_id") &&
        _.has(currentOption, "frontendPotentialDependencyTarget") &&
        _.get(currentOption, "frontendPotentialDependencyTarget");

      const hasLegacyOrphanMarker =
        _.get(currentOption, "option_id") &&
        !_.has(currentOption, "frontendPotentialDependencyTarget") &&
        !_.get(currentOption, "isDependencyTarget") &&
        _.get(currentOption, "dependentHidden") &&
        Object.prototype.hasOwnProperty.call(
          currentOption,
          "dependenciesVariable"
        );

      if (
        _.get(currentOption, "option_id") &&
        (
          _.get(currentOption, "isDependencyTarget") ||
          hasFrontendPotentialDependencyMarker ||
          hasLegacyOrphanMarker
        )
      ) {
        potentiallyDependentOptionIds.add(_.get(currentOption, "option_id"));
      }
    });

    _.each(this.selectedProduct.options, (option: any, index: number) => {
      if (!option || typeof option !== "object" || !option.option_id) {
        return;
      }

      this.selectedProduct.options[index].frontendPotentialDependencyTarget =
        potentiallyDependentOptionIds.has(option.option_id);
    });

    _.each(this.selectedProduct.options, (option, o, l) => {
      this.selectedProduct.options[o].dependenciesVariable = [];
    });

    _.each(this.selectedProduct.options, (option, o, l) => {
      _.each(this.selectedProduct.options[o].choices, (choice, c, list) => {
        if (!_.isEmpty(choice.dependentOptions)) {
          console.log(choice.title, choice.dependentOptions);

          _.each(choice.dependentOptions, (dependentOption, k, lo) => {
            console.log("dependentOption.option_id", dependentOption.option_id);
            var index = _.findIndex(this.selectedProduct.options, {
              option_id: dependentOption.option_id,
            });
            if (index !== -1) {
              this.selectedProduct.options[index].dependenciesVariable.push({
                when_is_preselected: true,
                option_id: option.option_id,
                optionTitle: option.title,
                choiceTitle: choice.title,
                choice_id: choice.choice_id,
                option_id_choice_id: choice.option_id_choice_id,
              });
            }
          });
        }

        if (!_.isEmpty(choice.dependenciesWhenNotPreselected)) {
          _.each(
            choice.dependenciesWhenNotPreselected,
            (dependentOption, k, lo) => {
              var index = _.findIndex(this.selectedProduct.options, {
                option_id: dependentOption.option_id,
              });
              if (index !== -1) {
                this.selectedProduct.options[index].dependenciesVariable.push({
                  when_is_preselected: false,
                  option_id: option.option_id,
                  optionTitle: option.title,
                  choiceTitle: choice.title,
                  choice_id: choice.choice_id,
                  option_id_choice_id: choice.option_id_choice_id,
                });
              }
            }
          );
        }
      });
    });
    this.hideShowDependentOptions();

    // Defensive: if a dependent option is present without its parent option in the payload,
    // it can end up with no dependencies and incorrectly render as an independent option.
    if (potentiallyDependentOptionIds.size > 0) {
      this.selectedProduct.options = _.filter(
        this.selectedProduct.options,
        (option: any) => {
          if (!option || typeof option !== "object" || !option.option_id) {
            return true;
          }

          if (!potentiallyDependentOptionIds.has(option.option_id)) {
            return true;
          }

          return (
            Array.isArray(option.dependenciesVariable) &&
            option.dependenciesVariable.length > 0
          );
        }
      );
    }
  }

  checkProductQuantityFromChoices(storeInfo) {
    if (this.selectedProduct.quantityOnlyFromChoices) {
      this.selectedProduct.quantity = 1;
      let quantityFromChoices = 0;
      _.each(this.selectedProduct.options, (option: any, o: any, q) => {
        if (
          this.selectedProduct.options &&
          this.selectedProduct.options[o] &&
          !_.isEmpty(this.selectedProduct.options[o]) &&
          this.selectedProduct.options[o].productQuantityChangeChoices &&
          this.selectedProduct.options[o].quantityInChoices
        ) {
          _.each(this.selectedProduct.options[o].choices, (choice, chIndex) => {
            if (
              this.selectedProduct.options[o].choices[chIndex].is_preselected &&
              (!this.selectedProduct.options[o].choices[chIndex].price ||
                this.selectedProduct.options[o].choices[chIndex].price ===
                  "0" ||
                this.selectedProduct.options[o].choices[chIndex].price ===
                  "0.00")
            ) {
              if (
                storeInfo?.bridge?.bridgeQuantityFromChoices &&
                this.selectedProduct.options[o].choices[chIndex]
                  .productQuantityMultiplier &&
                this.selectedProduct.options[o].choices[chIndex]
                  .productQuantityMultiplier > 1
              ) {
                this.selectedProduct.bridge_quantity_from_choices =
                  this.selectedProduct.options[o].choices[chIndex].quantity;
              }
              //Same rule as dm-mo-calculate-final-price: the choice quantity times
              //the multiplier (1 when it is missing or not a number), summed, and
              //the total kept to 3 decimals below
              const selectedChoice =
                this.selectedProduct.options[o].choices[chIndex];
              const parsedMultiplier = selectedChoice.productQuantityMultiplier
                ? parseFloat(
                    selectedChoice.productQuantityMultiplier.toString()
                  )
                : 1;
              const multiplier = isNaN(parsedMultiplier) ? 1 : parsedMultiplier;

              quantityFromChoices =
                quantityFromChoices +
                parseFloat(selectedChoice.quantity) * multiplier;
            }
          });
        }
      });

      //With no counted choice the quantity stays 1, as before
      if (quantityFromChoices > 0) {
        this.selectedProduct.quantity = roundQuantity(quantityFromChoices);
      }
    }
  }

  checkIfAnyChoiceDependencies(dependenciesVariable) {
    var found = false;

    _.each(this.selectedProduct.options, (option: any, o: any, q) => {
      if (
        this.selectedProduct.options &&
        this.selectedProduct.options[o] &&
        !_.isEmpty(this.selectedProduct.options[o]) &&
        (_.isEmpty(this.selectedProduct.options[o].dependenciesVariable) ||
          this.selectedProduct.options[o].showDependent) &&
        this.selectedProduct.options[o].activeTotal &&
        this.selectedProduct.options[o].availableTotal
      ) {
        _.each(this.selectedProduct.options[o].choices, (choice, c, w) => {
          if (choice.activeTotal && choice.availableTotal) {
            var foundChoice = _.filter(dependenciesVariable, {
              when_is_preselected: !!choice.is_preselected,
              option_id: option.option_id,
              choice_id: choice.choice_id,
            });

            if (foundChoice.length > 0) {
              found = true;
            }
          }
        });
      }
    });
    dependenciesVariable = null;
    return found;
  }

  hideShowDependentOptions() {
    console.log("hideShowDependentOptions", this.selectedProduct);

    var optionsThatAreDependent = _.filter(
      this.selectedProduct.options,
      (option) => {
        return (
          option &&
          typeof option === "object" &&
          option.dependenciesVariable &&
          option.dependenciesVariable.length > 0
        );
      }
    );

    _.each(optionsThatAreDependent, (option, key, list) => {
      this.selectedProduct.options[
        _.findIndex(this.selectedProduct.options, {
          option_id: option.option_id,
        })
      ].showDependent = this.checkIfAnyChoiceDependencies(
        option.dependenciesVariable
      );
    });
    optionsThatAreDependent = null;
  }

  selectedProductChanged(ChangedOption) {
    console.log("changed", ChangedOption, this.selectedProduct);
    if (this.selectedProduct && this.selectedProduct.options) {
      let optIndex = _.findIndex(this.selectedProduct.options, {
        option_id: ChangedOption.option_id,
      });
      if (optIndex !== -1) {
        this.selectedProduct.options[optIndex] = _.cloneDeep(ChangedOption);
        console.log("check dep options", ChangedOption);
        this.checkIsDependentOptions();

        this.store
          .select(selectors.getStoreInfo)
          .pipe(first())
          .subscribe((store_info) => {
            this.store
              .select("deliveryMethodAddress")
              .pipe(first())
              .subscribe((state) => {
                this.checkProductQuantityFromChoices(store_info);
                console.log(
                  ":call product price",
                  this.bundleMode,
                  this.parentBundleChoice
                );
                this.selectedProduct =
                  this.productDetailsOperationsService.cartProductPrice(
                    _.cloneDeep(this.selectedProduct),
                    state.orderPickup,
                    state.dineIn,
                    this.parentBundleChoice && this.bundleMode
                      ? _.cloneDeep(this.parentBundleChoice)
                      : null,
                    null,
                    store_info && store_info.dinein
                      ? store_info.alt_dinein_active
                      : false,
                    state.selectedDineInTable,
                    store_info.decimalPlacesPrices
                  );

                this.calculateIfShowFieldOption();
                this.writeProductToStateDebounce();
              })
              .unsubscribe();
          });
      } else {
        console.log("something went wrong");
      }
    }
  }

  writeProductToState() {
    this.store
      .select(selectors.getStoreInfo)
      .pipe(first())
      .subscribe((store_info) => {
        this.store
          .select("deliveryMethodAddress")
          .pipe(first())
          .subscribe((deliveryState) => {
            this.store
              .select("selectedProduct")
              .pipe(first())
              .subscribe((state) => {
                if (
                  state &&
                  state.clearSelectedBundleChoiceObject &&
                  state.clearSelectedBundleChoiceObject.product_id_option_id &&
                  state.clearSelectedBundleChoiceObject.option_id_choice_id &&
                  state.clearSelectedBundleChoiceObject.selectedProductId
                ) {
                  const newSelectedProductsArray = _.cloneDeep(
                    state.selectedProductsArray
                  );

                  const selectedProductIndex = _.findIndex(
                    state.selectedProductsArray,
                    {
                      selectedProductId:
                        state.clearSelectedBundleChoiceObject.selectedProductId,
                    }
                  );

                  if (selectedProductIndex !== -1) {
                    const selectedOptionIndex = _.findIndex(
                      state.selectedProductsArray[selectedProductIndex].options,
                      {
                        product_id_option_id:
                          state.clearSelectedBundleChoiceObject
                            .product_id_option_id,
                      }
                    );
                    if (selectedOptionIndex !== -1) {
                      const selectedBundleChoiceIndex = _.findIndex(
                        state.selectedProductsArray[selectedProductIndex]
                          .options[selectedOptionIndex].choices,
                        {
                          option_id_choice_id:
                            state.clearSelectedBundleChoiceObject
                              .option_id_choice_id,
                        }
                      );
                      if (selectedBundleChoiceIndex !== -1) {
                        this.selectedProduct.options[
                          selectedOptionIndex
                        ].choices[selectedBundleChoiceIndex].is_preselected =
                          false;

                        this.selectedProduct.options[
                          selectedOptionIndex
                        ].choices[selectedBundleChoiceIndex].bundled_product =
                          null;
                      }
                    }
                  }
                  this.store.dispatch(
                    new SelectedProductActions.clearSelectedBundleChoiceById({
                      product_id_option_id: null,
                      option_id_choice_id: null,
                      selectedProductId: null,
                    })
                  );
                  this.checkIsDependentOptions();
                  this.checkProductQuantityFromChoices(store_info);
                  this.productDetailsOperationsService.applyMoAppsIngoreAlwaysOpenOptions(
                    this.selectedProduct,
                    store_info
                  );
                  this.productDetailsOperationsService.applyUposTabletFullscreenAlwaysSplitColumns(
                    this.selectedProduct,
                    window.innerWidth
                  );
                  this.store.dispatch(
                    new SelectedProductActions.SetSelectedProduct(
                      _.cloneDeep(this.selectedProduct)
                    )
                  );

                  setTimeout(() => {
                    this.productDetailsOperationsService.cartProductPrice(
                      _.cloneDeep(this.selectedProduct),
                      deliveryState.orderPickup,
                      deliveryState.dineIn,
                      this.parentBundleChoice && this.bundleMode
                        ? _.cloneDeep(this.parentBundleChoice)
                        : null,
                      null,
                      store_info && store_info.dinein
                        ? store_info.alt_dinein_active
                        : false,
                      deliveryState.selectedDineInTable,
                      store_info.decimalPlacesPrices
                    );
                  }, 600);
                } else {
                  this.productDetailsOperationsService.applyMoAppsIngoreAlwaysOpenOptions(
                    this.selectedProduct,
                    store_info
                  );
                  this.productDetailsOperationsService.applyUposTabletFullscreenAlwaysSplitColumns(
                    this.selectedProduct,
                    window.innerWidth
                  );
                  this.store.dispatch(
                    new SelectedProductActions.SetSelectedProduct(
                      _.cloneDeep(this.selectedProduct)
                    )
                  );
                }
              })
              .unsubscribe();
          })
          .unsubscribe();
      })
      .unsubscribe();
  }

  calculateIfShowFieldOption() {
    this.store
      .select(selectors.getStoreInfo)
      .pipe(first())
      .subscribe((storeInfo) => {
        if (storeInfo && storeInfo.bridge_split_bundle_products) {
          let onlyBundleOptionsProduct = true;

          if (
            !this.selectedProduct.options ||
            (this.selectedProduct.options &&
              this.selectedProduct.options.length === 1)
          ) {
            onlyBundleOptionsProduct = false;
          }

          _.each(this.selectedProduct.options, (opt) => {
            if (!opt.bundle && !(opt.default || opt.template === "comments")) {
              onlyBundleOptionsProduct = false;
            }
          });
          if (onlyBundleOptionsProduct) {
            this.do_not_show_comments_option = true;
          } else {
            if (
              this.selectedProduct &&
              this.selectedProduct.hideCommentsOption
            ) {
              this.do_not_show_comments_option = true;
            } else {
              this.do_not_show_comments_option = false;
            }
          }
        } else if (
          this.selectedProduct &&
          this.selectedProduct.hideCommentsOption
        ) {
          this.do_not_show_comments_option = true;
        } else {
          this.do_not_show_comments_option = false;
        }
      })
      .unsubscribe();
  }

  //Debounce for writing to state we also have debounce on check-box-choices and radio-choices component for every option
  // You must to sychronize these two debounces to avoid bugs when you change a choice (the other debounce is 600)
  writeProductToStateDebounce = _.debounce(() => {
    this.writeProductToState();
  }, 20);

  // Paint the first chunk of options immediately and append the rest in small batches
  // over the next animation frames. For products with <= optionsInitialChunk options
  // everything renders at once (no behaviour change). The full list is always rendered
  // within a few frames — before the user can reach Add-to-cart — so per-option
  // validation, pricing and scroll-to-error keep working exactly as before.
  initProgressiveOptions() {
    const optionsLength =
      this.selectedProduct && this.selectedProduct.options
        ? this.selectedProduct.options.length
        : 0;

    if (optionsLength <= this.optionsInitialChunk) {
      this.visibleOptionsCount = optionsLength;
      this.optionsProgressiveDone = true;
      return;
    }

    this.visibleOptionsCount = this.optionsInitialChunk;
    this.optionsProgressiveDone = false;
    this.scheduleNextOptionsChunk();
  }

  scheduleNextOptionsChunk() {
    if (typeof requestAnimationFrame !== "function") {
      this.renderAllOptionsNow();
      return;
    }
    this.optionsRafId = requestAnimationFrame(() => {
      const optionsLength =
        this.selectedProduct && this.selectedProduct.options
          ? this.selectedProduct.options.length
          : 0;

      this.visibleOptionsCount = Math.min(
        this.visibleOptionsCount + this.optionsChunkSize,
        optionsLength
      );

      if (this.visibleOptionsCount < optionsLength) {
        this.scheduleNextOptionsChunk();
      } else {
        this.optionsProgressiveDone = true;
        this.optionsRafId = null;
        this.teardownValidationFlush();
      }
    });
  }

  // Safeguard: render every option immediately. Triggered when a validation pass is
  // requested (e.g. on Add-to-cart) so a not-yet-rendered option can never be skipped
  // by the per-option validation flow.
  renderAllOptionsNow() {
    if (this.optionsRafId != null && typeof cancelAnimationFrame === "function") {
      cancelAnimationFrame(this.optionsRafId);
    }
    this.optionsRafId = null;
    this.optionsProgressiveDone = true;
    this.visibleOptionsCount =
      this.selectedProduct && this.selectedProduct.options
        ? this.selectedProduct.options.length
        : 0;
    this.teardownValidationFlush();
    // Force the just-revealed options to mount and run their per-option validation
    // synchronously, so a fast Add-to-cart can't read the validation snapshot before
    // every option has registered. Guarded so it can never break the add-to-cart flow
    // (falls back to the normal async CD + 400ms validation debounce if CD is busy).
    try {
      this.cdr.detectChanges();
    } catch (e) {}
  }

  private teardownValidationFlush() {
    if (this.validationFlushSub) {
      this.validationFlushSub.unsubscribe();
    }
  }

  subscribeToValidationFlush() {
    this.validationFlushSub = this.store
      .select("productOptionsValidation")
      .subscribe((state: any) => {
        const selectedProductId =
          this.selectedProduct && this.selectedProduct.selectedProductId;
        const timestamp =
          state &&
          state.lastValidTimestampBySelectedProductId &&
          selectedProductId
            ? state.lastValidTimestampBySelectedProductId[selectedProductId]
            : null;

        // Ignore the value already present when the modal opened; only react to a
        // genuinely new validation request, and only while still rendering.
        if (!this.validationFlushInitialized) {
          this.validationFlushInitialized = true;
          this.lastSeenValidationTimestamp = timestamp;
          return;
        }

        if (
          !this.optionsProgressiveDone &&
          timestamp &&
          timestamp !== this.lastSeenValidationTimestamp
        ) {
          this.lastSeenValidationTimestamp = timestamp;
          this.renderAllOptionsNow();
        } else {
          this.lastSeenValidationTimestamp = timestamp;
        }
      });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.validationFlushSub) {
      this.validationFlushSub.unsubscribe();
    }
    if (this.optionsRafId != null && typeof cancelAnimationFrame === "function") {
      cancelAnimationFrame(this.optionsRafId);
    }
  }
}
